import React from 'react'
import {style} from '../../util/style'
import {CtaDonation, CtaDonationType} from '../layout/cta/CtaDonation'
import {CtaMagazine, CtaMagazineType} from '../layout/cta/CtaMagazine'
import {CtaSupport, CtaSupportType} from '../layout/cta/CtaSupport'
import {Block} from './Blocks'

const styles = style('ctagiftblock')

export type CtaGiftBlockType = {
	ctagift: {
		channel: string
	} & (CtaDonationType | CtaMagazineType | CtaSupportType)
}

export const CtaGiftBlock: React.FC<
	CtaGiftBlockType & {container?: boolean; sidebar?: boolean}
> = ({container, sidebar, ctagift}) => {
	if (!ctagift || !ctagift.channel) return null

	return (
		<Block className={styles()} sidebar={sidebar}>
			{renderSwitch(ctagift, container, sidebar)}
		</Block>
	)
}

function renderSwitch(ctagift, container, sidebar) {
	switch (ctagift.channel) {
		case 'cta_donation':
			return (
				<CtaDonation {...ctagift} container={container} sidebar={sidebar} />
			)
		case 'cta_magazine':
			return (
				<CtaMagazine {...ctagift} container={container} sidebar={sidebar} />
			)
		case 'cta_support':
			return <CtaSupport {...ctagift} container={container} sidebar={sidebar} />
	}
}
